// ============================================================
// SMART CARD LAYOUT ENGINE — SmartMedia (render type-aware)
// ============================================================
// Extracción del patrón existente (feed + ProductView) SIN cambio de
// comportamiento: mismo DOM, mismas clases, misma política de media
// (object-fit: contain vía .product-media — index.css — NUNCA cover).
// ============================================================
import React from 'react';

export interface SmartMediaItem {
  type?: 'image' | 'video';
  url: string;
}

interface SmartMediaProps {
  /** media[] tipado (nuevo formato) o undefined */
  media?: SmartMediaItem[];
  /** images[] legacy (fallback por extensión) */
  images?: string[];
  /** bloqueado → sin hover scale */
  blocked?: boolean;
  /** relación de aspecto del marco (clase Tailwind) */
  ratioClass?: string;
  /** texto alternativo (lo decide el consumidor — el motor es agnóstico) */
  alt?: string;
  className?: string;
}

/** Detecta video por extensión (productos legacy/backward-compat) */
const isVideoUrl = (url: string) => /\.(mp4|mov|webm)$/i.test(url);

export const SmartMedia: React.FC<SmartMediaProps> = ({
  media,
  images,
  blocked = false,
  ratioClass = 'aspect-[3/4]',
  alt = '',
  className = '',
}) => {
  const primary = media?.[0] ||
    { type: isVideoUrl(images?.[0] || '') ? 'video' : 'image', url: images?.[0] };

  const mediaClass = 'w-full h-full transition-transform duration-300 ' +
    (blocked ? '' : 'hover:scale-105');

  return (
    <div className={`${ratioClass} bg-gray-100 overflow-hidden relative product-media ${className}`}>
      {primary.type === 'video'
        ? <video src={primary.url} muted playsInline preload="metadata" className={mediaClass} />
        : <img src={primary.url} alt={alt} className={mediaClass} />}
    </div>
  );
};

export default SmartMedia;
